<template>
  <div
    v-if="isValid()"
    class="c-map-tooltip-car-content"
    :style="`font-size: ${font_size}px`"
  >
    <ul>
      <li><b>{{ item.number }}</b> / {{ classTime.toMin(item.timeToPreviousVehicle, '') }}</li>
    </ul>

    <ul class="list-hover">
      <li>Швидкість: <b>{{ classVehicle.speed(item.speed) }}</b></li>
      <li>Час передачі сигналу: <b>{{ classTime.timestampToLocaleTime(item.timestamp) }}</b></li>
    </ul>
  </div>
</template>

<script>
import { ClassTime } from '@/helpers/base'
import { ClassVehicle } from '@/helpers/cars'
export default {
  name: 'c-map-tooltip-car-content',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    font_size: {
      type: Number,
      default: 12
    },
  },
  data() {
    return {
      classTime: new ClassTime(),
      classVehicle: new ClassVehicle()
    }
  },
  methods: {
    /* Хэлперы */
    isValid() {
      return Object.keys(this.item).length != 0
    },
    /* Хэлперы END */
  }
}
</script>

<style lang="scss">
  .leaflet-custom-tooltip {
    background: rgba(255, 255, 255, 0.5)!important;
    text-shadow: 0 0 1px #fff;
  }
  .c-map-tooltip-car-content {
    b {
      font-weight: 600;
    }
    ul {
      list-style: none;
      padding: 0 !important;
      text-align: left;
    }
    li {
      padding: 0 5px;
      white-space: nowrap;
    }
  }
</style>